// import TextField from "@mui/material/TextField/TextField";
// import Grid from "@mui/material/Grid/Grid";
import React from "react";
import {makeStyles} from "@mui/styles";
// import InputMask from "react-input-mask";
// import InputLabel from "@mui/material/InputLabel/InputLabel";
import Select from "@mui/material/Select/Select";
import FormHelperText from "@mui/material/FormHelperText/FormHelperText";
import FormControl from "@mui/material/FormControl/FormControl";
import CancelIcon from '@mui/icons-material/Cancel';
import OutlinedInput from "@mui/material/OutlinedInput/OutlinedInput";
import {CustomLabelXSmallRegular} from "../CustomLabel";
import Box from "@mui/material/Box/Box";

const useStyles = makeStyles(() => ({
    notchedOutline: {
        borderWidth: "0px",
        borderColor: "#F1F4F3 !important",
    },
    root: {
        color:"white",
        "& .MuiInputBase-root": {
            background: "transparent",
            borderRadius:20,

            border:"1.5px solid #F5F5F5"

        },

        "& .MuiInputLabel-standard": {
            color: "black",
            fontSize:"21px"
        },
    },


    notchedOutlineSearch: {
        borderWidth: "2px",
        borderColor: "#F1F4F3 !important",
    },
    rootSearch: {
        "& .MuiInputBase-root": {
            height: "40px",
            borderRadius: "20px"
        }
    },
    paper: {
       // maxHeight:"300px"
    },

}));


const getDropdownValue=(value,showShort)=>{
    if(!showShort){
        return value && Array.isArray(value) && value.join(",")
    }else if(value.length>0 && showShort){
        return `${value.length} Stack Selected`
    }
}

const CustomDropdown = (props) => {
    const {onClear}=props;
    const classes = useStyles();
    return (
        <FormControl fullWidth>

            {(!props.value || props.value.length<1) &&
                <span style={{position: "absolute", top: 21, left: 50, zIndex: 10}}>
            <CustomLabelXSmallRegular text={props.placeholder} color={"#A3A3A3"}/>
            </span>
            }
            <Select
                MenuProps={{
                    classes: {
                        paper: classes.paper
                    }
                }}
                value={props.value}
                onChange={props.onChange}
                className={classes.root}
                style={{height: "60px", background: "white", borderRadius: 20, fontSize: 12,border:"1.5px solid #DDDDDD", fontWeight: "bold"}}
                disabled={props.disabled}
                multiple={props.multiple}
                autoFocus={props.autoFocus}
                input={
                    <OutlinedInput
                        placeholder="Select an option"
                        startAdornment={props.startAdornment}
                    />
                }
                renderValue={((selected) => {
                    return <Box sx={{
                        overflow: "hidden",
                        maxWidth:"100%",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color:'black'
                    }}>
                        {getDropdownValue(selected,props.short)}
                    </Box>
                })}
                sx={{

                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 0,
                    },
                    '& .MuiList-root':{
                    },
                    maxWidth:"100%"
                }}
                IconComponent={props.showClear && ((props) => <CancelIcon
                                                      style={{cursor: "pointer",zIndex:1,marginRight:5,}}
                                                      onClick={onClear}/>)}


            >
                {props.container}
            </Select>
            {props.showError && <FormHelperText
                style={{
                    fontSize: "0.75rem",
                    textAlign: "left",
                    color: "#d32f2f",
                    fontWeight: "400",
                    marginLeft:'-3px'
                }}>
                {props.error}</FormHelperText>}
        </FormControl>

    )
}


export {CustomDropdown};
